import { DEFAULT_AVATAR_REGISTRY } from "../features/avatarOverlay/avatarRegistry";

export const ARTI = DEFAULT_AVATAR_REGISTRY.arti;
export const ARTI_AGENT = ARTI.id;
export const ARTI_NAME = ARTI.name;
export const ARTI_ROLE = ARTI.role;
export const ARTI_ACCENT = ARTI.accent;
export const ARTI_VOICE_KEY = "forgelinc.arti.voice.v1";
export const ARTI_ASK_EVENT = "forgelinc:arti-ask";
export const ARTI_TALK_EVENT = "forgelinc:arti-talk";
export const ARTI_TTS = Object.freeze({
  rate: 1.04,
  pitch: 1.12,
  preferVoices: Object.freeze(["Samantha", "Google UK English Female", "Female"]),
});

const GENERATE_RE = /^(?:please\s+)?generate(?:\s+(?:this|a|an|the|me))?\s*(.*)$/i;
const EDIT_RE = /^(?:please\s+)?(?:continue editing|edit(?:\s+(?:this|the image|it|image))?)\s*(.*)$/i;
const REFERENCE_RE = /^(?:please\s+)?(?:use as reference|set as (?:source|reference)|make this the source)\s*(.*)$/i;

export function matchArtiDeskCommand(text) {
  const raw = String(text || "").trim();
  if (!raw) return { kind: "prompt", prompt: "" };
  const edit = raw.match(EDIT_RE);
  if (edit) return { kind: "edit", prompt: String(edit[1] || "").trim() };
  const reference = raw.match(REFERENCE_RE);
  if (reference) return { kind: "reference", prompt: String(reference[1] || "").trim() };
  const generate = raw.match(GENERATE_RE);
  if (generate) return { kind: "generate", prompt: String(generate[1] || "").trim() };
  return { kind: "chat", prompt: raw };
}

export function buildArtiChatPayload(message, history = []) {
  const text = String(message || "").trim();
  const turns = (history || [])
    .filter((row) => row && (row.role === "user" || row.role === "assistant") && String(row.content || "").trim())
    .slice(-12)
    .map((row) => ({ role: row.role, content: String(row.content).trim() }));
  return { message: text, history: turns };
}

export function suggestedDesignPrompt(payload) {
  return String(payload?.image_prompt || "").trim();
}

export function artiAck(kind) {
  switch (kind) {
    case "hello":
    case "hello_chat":
      return "I'm Arti. Talk with me — ask questions, then I can put a prompt on the design input when you want it.";
    case "listening":
      return "I'm listening.";
    case "heard":
      return "Got it.";
    case "heard_prompt":
      return "Got it. That's on the design input.";
    case "sent_to_prompt":
      return "That prompt is in the design input. Generate when you're ready.";
    case "generate":
      return "On it. Generating a fresh take.";
    case "generate_done":
      return "Fresh render is on the desk.";
    case "edit":
      return "Continuing from the source image.";
    case "edit_done":
      return "Edit saved.";
    case "reference":
      return "Using that as the source.";
    case "need_prompt":
      return "Tell me what you want, or type a design prompt first.";
    case "need_source":
      return "Upload a reference or pick an iteration first.";
    case "need_iteration":
      return "Pick an iteration first.";
    case "unsupported":
      return "Voice input isn't available here. Type to me instead.";
    case "mic_failed":
      return "I couldn't start the mic. You can still type.";
    case "error":
      return "That didn't go through. The last good take is still on the desk.";
    default:
      return "I'm here. Talk with me.";
  }
}
